<template>
  <div class='cv sections'>
    <div id="body_textarea_span" name="resume">
      <div class='resume-container'>
        <h2>RESUME</h2>
        <div class='pdf-controls'>
          <a href="./Resume.pdf" target="_blank" class='download-btn'>
            <span class='icon'>⬇</span> Download PDF
          </a>
          <a href="./Resume.pdf" target="_blank" class='view-btn'>
            <span class='icon'>👁</span> Open in New Tab
          </a>
        </div>
        
        <!-- Desktop PDF viewer -->
        <div class='pdf-viewer' v-if="!isMobile">
          <object 
            :data="'./Resume.pdf#toolbar=1&navpanes=0&scrollbar=1'"
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <iframe 
              :src="'./Resume.pdf#toolbar=1&navpanes=0&scrollbar=1'" 
              width="100%"
              height="100%"
            >
              <p>Your browser does not support PDFs. 
                <a href="./Resume.pdf" target="_blank" class='fallback-link'>Download the PDF</a>.
              </p>
            </iframe>
          </object>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name: "Resume",
  components: {},
  data(){
    return{
      isMobile: false
    }
  },
  mounted() {
    // Detect mobile devices
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
                    || window.innerWidth < 768;
  }
}

</script>
<style lang="scss" scoped>

/* Modern Resume section */
div.cv {
    width: 100%;
    clear: both;
    background: $gradient-light;
    padding: 60px 20px 80px;
}

h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    color: $text-dark;
    margin-bottom: 30px;
    letter-spacing: 0.5px;
}

.resume-container {
    max-width: 900px;
    margin: 0 auto;
}

.pdf-controls {
    text-align: center;
    margin-bottom: 30px;
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;
}

.download-btn, .view-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 28px;
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
    font-size: 1rem;
}

.download-btn {
    background-color: #2563eb;
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
}

.download-btn:hover {
    background-color: #1e40af;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.view-btn {
    background-color: #059669;
    box-shadow: 0 2px 8px rgba(5, 150, 105, 0.2);
}

.view-btn:hover {
    background-color: #047857;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.icon {
    font-size: 1.2rem;
}

.pdf-viewer {
    background: $bg-white;
    border-radius: $border-radius-md;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    height: 800px;
}

.pdf-viewer object,
.pdf-viewer iframe {
    display: block;
}

.fallback-link {
    color: $primary;
    font-weight: 600;
    text-decoration: underline;
}

.mobile-message {
    background: $bg-white;
    border-radius: $border-radius-md;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 60px 30px;
    text-align: center;
}

.message-card {
    max-width: 400px;
    margin: 0 auto;
}

.message-card p {
    font-size: 1.25rem;
    color: #1f2937;
    margin-bottom: 15px;
    font-weight: 600;
}

.sub-text {
    font-size: 1rem;
    color: #6b7280;
    font-weight: 400;
}

@media screen and (max-width: 768px) {
    .pdf-viewer {
        height: 600px;
    }
    
    div.cv {
        padding: 40px 15px 60px;
    }
    
    .pdf-controls {
        flex-direction: column;
        align-items: stretch;
    }
    
    .download-btn, .view-btn {
        width: 100%;
        max-width: 300px;
        margin: 0 auto;
    }
}

</style>
